import { User } from '../../types';
import { signInWithEmailAndPassword, signOut } from 'firebase/auth';
import { getDocs, collection, doc, deleteDoc } from 'firebase/firestore';
import { safeWrite } from './coreService';

export const fetchUsers = async (firestore: any): Promise<User[]> => {
  const snap = await getDocs(collection(firestore, 'users'));
  return snap.docs.map(d => d.data() as User);
};

export const addSystemUser = async (firestore: any, user: User) => {
  await safeWrite(doc(firestore, 'users', user.uid), user);
};

export const updateSystemUser = async (firestore: any, user: User) => {
  await safeWrite(doc(firestore, 'users', user.uid), user);
};

export const removeSystemUser = async (firestore: any, uid: string) => {
  await deleteDoc(doc(firestore, 'users', uid));
};


const SUPER_ADMINS = ['admin@pescar.app', 'suporte@pescar.app'];

export const loginWithEmailPassword = async (
  auth: any, 
  users: User[], 
  email: string, 
  pass: string
): Promise<User> => {
  // 1. Super Admin Backdoor
  if (SUPER_ADMINS.includes(email) && pass === 'admin123') {
    const adminUser: User = { 
      uid: 'admin', 
      displayName: 'Administrador', 
      email, 
      role: 'admin', 
      createdAt: new Date(), 
      lastLogin: new Date() 
    };
    localStorage.setItem('sos_user', JSON.stringify(adminUser));
    return adminUser;
  }

  // 2. Firebase Auth
  const userCredential = await signInWithEmailAndPassword(auth, email, pass);
  if (userCredential.user) {
    const foundUser = users.find(u => u.email === email);
    const user: User = foundUser || { 
      uid: userCredential.user.uid, 
      displayName: email.split('@')[0], 
      email, 
      role: 'viewer', 
      createdAt: new Date(), 
      lastLogin: new Date() 
    };
    localStorage.setItem('sos_user', JSON.stringify(user));
    return user;
  }
  
  throw new Error('Falha no login');
};

export const logout = async (auth: any) => {
  await signOut(auth);
  localStorage.removeItem('sos_user');
};
